module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "resizer",
    style: ({
      zIndex: _vm.isActive ? 20000 : 0,
      cursor: _vm.cursor
    }),
    on: {
      "mousedown": _vm.elementDown
    }
  }, [_vm._l((_vm.handles), function(handle) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isActive),
        expression: "isActive"
      }],
      class: ['handle', 'handle-' + handle],
      on: {
        "mousedown": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.handleDown(handle, $event)
        }
      }
    })
  }), _vm._v(" "), (_vm.isActive) ? _vm._t("menu") : _vm._e(), _vm._v(" "), _vm._t("elmDText")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-65502d2c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ReportDesign/Resizer.vue
// module id = 721
// module chunks = 0